import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {ProductLineItem} from "../types.ts";
import {formatTimestamp, TIMESTAMP_PLACEHOLDER} from "../../../utils/TableTimestamps.tsx";

// Every column is sortable (§3a). The `accessor` is what sorts: `productFeature.name` is a
// dotted path the shared comparator reads, `position` sorts as a number, `created` and
// `updated` as ISO-8601 strings, nulls last in both directions (shared sortRecords). Empty
// values render the shared placeholder (§13). Opening a row is the table's onRowClick,
// gated on UpdateProductLineItem there, not a link drawn in a cell.
export const useProductLineItemsTableColumns = () => {

    const columns: DataTableColumn<ProductLineItem>[] = [
        {
            accessor: 'productFeature.name',
            title: I18n.get('Feature'),
            width: '2fr',
            sortable: true,
            render: (record: ProductLineItem) => record.productFeature?.name || record.productFeatureId || TIMESTAMP_PLACEHOLDER,
        },
        {
            accessor: 'position',
            title: I18n.get('Position'),
            width: '120px',
            sortable: true,
            render: (record: ProductLineItem) => typeof record.position === 'number' ? record.position : TIMESTAMP_PLACEHOLDER,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            sortable: true,
            render: (record: ProductLineItem) => formatTimestamp(record.created),
        },
        {
            accessor: 'updated',
            title: I18n.get('Last Updated'),
            width: '1fr',
            sortable: true,
            render: (record: ProductLineItem) => formatTimestamp(record.updated),
        },
    ];

    return {
        columns,
    };
};
